import React, { useState, useEffect } from 'react';
import './Platillos.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import FormModal from '../common/FormModal';
import FormField from '../common/FormField';
import FormGrid, { FormGridFullWidth } from '../common/FormGrid';
import SearchBar from '../common/SearchBar';
import { useToast } from '../../contexts/ToastContext';
import { getApiUrl } from '../../utils/api';
import Select from 'react-select';
import { FaSave, FaEdit, FaPlus, FaUtensils, FaPrint, FaEye, FaTh, FaDollarSign, FaBarcode, FaBoxOpen, FaPalette, FaTrashAlt, FaList, FaArrowLeft, FaBook, FaTimes } from 'react-icons/fa';
import RecetaModal from './RecetaModal';

const Platillos = () => {
  const [platillos, setPlatillos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [impresoras, setImpresoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [platilloSeleccionado, setPlatilloSeleccionado] = useState(null);

  const [formData, setFormData] = useState({
    nombre: '',
    precio: '',
    costo: '',
    codigo: '',
    imagen: '',
    idCategoria: '',
    impresora: '',
    impresora2: '',
    imprimirCocina: 0,
    existencia: '',
    utilizaDisponibles: 0,
    disponibles: '0',
    title: '',
    titleSize: '14',
    precioSize: '12',
    posicionX: '0',
    posicionY: '0',
    width: '100',
    height: '100',
    posicionTitle: '',
    colorFondo: '#FFFFFF',
    colorTitulo: '#000000',
    colorLetra: '#000000'
  });

  // Modal nueva categoría
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [guardandoCategoria, setGuardandoCategoria] = useState(false);
  const [categoriaFormData, setCategoriaFormData] = useState({
    nombre: '',
    imagen: '',
    impresora: '',
    titleSize: '14',
    posicionX: '0',
    posicionY: '0',
    width: '100',
    height: '100',
    posicionTitle: '',
    colorFondo: '#FFFFFF',
    colorTitulo: '#000000',
    colorLetra: '#000000'
  });

  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [vista, setVista] = useState('platillos'); // 'platillos' | 'categorias'

  // Modal receta
  const [showRecetaModal, setShowRecetaModal] = useState(false);
  const [platilloReceta, setPlatilloReceta] = useState(null);

  // Modal ver costos
  const [showCostosModal, setShowCostosModal] = useState(false);
  const [busquedaCostos, setBusquedaCostos] = useState('');
  const [preparados, setPreparados] = useState([]);
  const [tabCostos, setTabCostos] = useState('platillos');

  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const toast = useToast();

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [resPlatillos, resCategorias] = await Promise.all([
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getTodosLosPlatillos' })
        }),
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getCategorias' })
        })
      ]);

      const dataPlatillos = await resPlatillos.json();
      const dataCategorias = await resCategorias.json();

      if (dataPlatillos.success) {
        setPlatillos(dataPlatillos.data || []);
      } else {
        toast.error(dataPlatillos.message);
      }

      if (dataCategorias.success) {
        setCategorias(dataCategorias.data || []);
      }

      // Cargar impresoras del sistema operativo
      if (window.electron && window.electron.ipcRenderer) {
        try {
          const systemPrinters = await window.electron.ipcRenderer.invoke('get-all-printers');
          if (Array.isArray(systemPrinters)) {
            setImpresoras(systemPrinters.map(p => ({
              value: p.name,
              label: p.displayName || p.name
            })));
          }
        } catch (printerError) {
          console.error('Error al obtener impresoras:', printerError);
        }
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar platillos');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }));
  };

  const nuevoPlatillo = () => {
    setFormData({
      nombre: '',
      precio: '',
      costo: '',
      codigo: '',
      imagen: '',
      idCategoria: '',
      impresora: '',
      impresora2: '',
      imprimirCocina: 0,
      existencia: '',
      utilizaDisponibles: 0,
      disponibles: '0',
      title: '',
      titleSize: '14',
      precioSize: '12',
      posicionX: '0',
      posicionY: '0',
      width: '100',
      height: '100',
      posicionTitle: '',
      colorFondo: '#FFFFFF',
      colorTitulo: '#000000',
      colorLetra: '#000000'
    });
    setPlatilloSeleccionado(null);
    setShowModal(true);
  };

  const editarPlatillo = async (platillo) => {
    // Fetch full platillo details to get all fields
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'getPlatillo', idPlatillo: platillo.idProducto })
      });
      const data = await response.json();

      if (data.success) {
        const p = data.data;
        setFormData({
          nombre: p.nombre || '',
          precio: p.precio || '',
          costo: p.costo || '',
          codigo: p.codigo || '',
          imagen: p.imagen || '',
          idCategoria: p.idCategoria || '',
          impresora: p.impresora || '',
          impresora2: p.impresora2 || '',
          imprimirCocina: p.imprimirCocina ? 1 : 0,
          existencia: p.existencia || '',
          utilizaDisponibles: p.utilizaDisponibles ? 1 : 0,
          disponibles: p.disponibles || '',
          title: p.title || '',
          titleSize: p.titleSize || '',
          precioSize: p.precioSize || '',
          posicionX: p.posicionX || '',
          posicionY: p.posicionY || '',
          width: p.width || '',
          height: p.height || '',
          posicionTitle: p.posicionTitle || '',
          colorFondo: p.colorFondo || '',
          colorTitulo: p.colorTitulo || '',
          colorLetra: p.colorLetra || ''
        });
        setPlatilloSeleccionado(platillo);
        setShowModal(true);
      } else {
        toast.error('Error al obtener detalle del platillo');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al obtener detalle del platillo');
    }
  };

  const guardarPlatillo = async () => {
    try {
      setGuardando(true);

      if (!formData.nombre.trim()) {
        toast.error('El nombre del platillo es obligatorio');
        return;
      }

      if (!formData.idCategoria) {
        toast.error('Debe seleccionar una categoría');
        return;
      }

      const esEdicion = !!platilloSeleccionado;
      const payload = {
        tipo: esEdicion ? 'actualizarPlatillo' : 'crearPlatillo',
        ...formData,
        title: formData.nombre
      };

      if (esEdicion) {
        payload.idPlatillo = platilloSeleccionado.idProducto;
      }

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        const nombreCategoria = categorias.find(c => String(c.idCategoria) === String(formData.idCategoria))?.nombre || 'Sin categoría';

        if (esEdicion) {
          setPlatillos(prev => prev.map(p =>
            p.idProducto === platilloSeleccionado.idProducto
              ? { ...p, nombre: formData.nombre, precio: parseFloat(formData.precio) || 0, costo: parseFloat(formData.costo) || 0, codigo: formData.codigo, idCategoria: parseInt(formData.idCategoria), nombreCategoria, impresora: formData.impresora }
              : p
          ));
        } else {
          const nuevoPlatilloData = {
            idProducto: data.data?.idPlatillo,
            nombre: formData.nombre,
            precio: parseFloat(formData.precio) || 0,
            costo: parseFloat(formData.costo) || 0,
            codigo: formData.codigo,
            idCategoria: parseInt(formData.idCategoria),
            nombreCategoria,
            impresora: formData.impresora,
            imagen: '',
            disponible: true
          };
          setPlatillos(prev => [...prev, nuevoPlatilloData]);
        }

        toast.success(esEdicion ? 'Platillo actualizado correctamente' : 'Platillo creado correctamente');
        handleCloseModal();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al guardar platillo:', error);
      toast.error('Error al guardar platillo');
    } finally {
      setGuardando(false);
    }
  };

  const eliminarPlatillo = async (platillo) => {
    if (!window.confirm(`¿Está seguro de eliminar el platillo "${platillo.nombre}"?`)) {
      return;
    }

    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'eliminarPlatillo', idPlatillo: platillo.idProducto })
      });

      const data = await response.json();

      if (data.success) {
        setPlatillos(prev => prev.filter(p => p.idProducto !== platillo.idProducto));
        toast.success('Platillo eliminado correctamente');
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al eliminar platillo:', error);
      toast.error('Error al eliminar platillo');
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setPlatilloSeleccionado(null);
    setFormData({
      nombre: '',
      precio: '',
      costo: '',
      codigo: '',
      imagen: '',
      idCategoria: '',
      impresora: '',
      impresora2: '',
      imprimirCocina: 0,
      existencia: '',
      utilizaDisponibles: 0,
      disponibles: '0',
      title: '',
      titleSize: '14',
      precioSize: '12',
      posicionX: '0',
      posicionY: '0',
      width: '100',
      height: '100',
      posicionTitle: '',
      colorFondo: '#FFFFFF',
      colorTitulo: '#000000',
      colorLetra: '#000000'
    });
  };

  // --- Funciones de categoría ---
  const handleCategoriaInputChange = (e) => {
    const { name, value } = e.target;
    setCategoriaFormData(prev => ({ ...prev, [name]: value }));
  };

  const nuevaCategoria = () => {
    setCategoriaFormData({
      nombre: '',
      imagen: '',
      impresora: '',
      titleSize: '14',
      posicionX: '0',
      posicionY: '0',
      width: '100',
      height: '100',
      posicionTitle: '',
      colorFondo: '#FFFFFF',
      colorTitulo: '#000000',
      colorLetra: '#000000'
    });
    setCategoriaSeleccionada(null);
    setShowCategoriaModal(true);
  };

  const editarCategoria = (categoria) => {
    setCategoriaFormData({
      nombre: categoria.nombre || '',
      imagen: categoria.imagen || '',
      impresora: categoria.impresora || '',
      titleSize: String(categoria.titleSize || '14'),
      posicionX: String(categoria.posicionX || '0'),
      posicionY: String(categoria.posicionY || '0'),
      width: String(categoria.width || '100'),
      height: String(categoria.height || '100'),
      posicionTitle: categoria.posicionTitle || '',
      colorFondo: categoria.colorFondo || '#FFFFFF',
      colorTitulo: categoria.colorTitulo || '#000000',
      colorLetra: categoria.colorLetra || '#000000'
    });
    setCategoriaSeleccionada(categoria);
    setShowCategoriaModal(true);
  };

  const eliminarCategoria = async (categoria) => {
    if (!window.confirm(`¿Está seguro de eliminar la categoría "${categoria.nombre}"?`)) {
      return;
    }

    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'eliminarCategoria', idCategoria: categoria.idCategoria })
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Categoría eliminada correctamente');
        cargarDatos();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al eliminar categoría:', error);
      toast.error('Error al eliminar categoría');
    }
  };

  const guardarCategoria = async () => {
    try {
      setGuardandoCategoria(true);

      if (!categoriaFormData.nombre.trim()) {
        toast.error('El nombre de la categoría es obligatorio');
        return;
      }

      const esEdicion = !!categoriaSeleccionada;
      const payload = {
        tipo: esEdicion ? 'actualizarCategoria' : 'crearCategoria',
        ...categoriaFormData
      };

      if (esEdicion) {
        payload.idCategoria = categoriaSeleccionada.idCategoria;
      }

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        toast.success(esEdicion ? 'Categoría actualizada correctamente' : 'Categoría creada correctamente');
        setShowCategoriaModal(false);
        setCategoriaSeleccionada(null);
        cargarDatos();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error al guardar categoría:', error);
      toast.error('Error al guardar categoría');
    } finally {
      setGuardandoCategoria(false);
    }
  };

  const cargarPreparados = async () => {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'getTodosLosPreparados' })
      });
      const data = await response.json();
      if (data.success) {
        setPreparados(data.data || []);
      }
    } catch (error) {
      console.error('Error al cargar preparados:', error);
    }
  };

  const abrirCostosModal = () => {
    setBusquedaCostos('');
    setTabCostos('platillos');
    cargarPreparados();
    setShowCostosModal(true);
  };

  // Filtrar platillos
  const platillosFiltrados = platillos.filter(p => {
    const coincideNombre = p.nombre && p.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
    const coincideCategoria = !filtroCategoria || String(p.idCategoria) === String(filtroCategoria);
    return coincideNombre && coincideCategoria;
  });

  const categoriasOptions = categorias.map(c => ({
    value: String(c.idCategoria),
    label: c.nombre
  }));

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '36px',
      borderColor: state.isFocused ? '#FF9800' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(255, 152, 0, 0.1)' : 'none',
      '&:hover': { borderColor: '#FF9800' }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#FF9800' : state.isFocused ? '#FFF3E0' : 'white',
      color: state.isSelected ? 'white' : '#333',
      fontSize: '13px'
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (base) => ({ ...base, fontSize: '13px' }),
    singleValue: (base) => ({ ...base, fontSize: '13px' })
  };

  if (loading) {
    return (
      <div className="platillos-container">
        <div className="platillos-loading">Cargando platillos...</div>
      </div>
    );
  }

  return (
    <div className="platillos-container">
      <Header titulo='Platillos' color='#FF9800' />
      <div className="platillos-content">
        <div className="platillos-inner">
          <div className="platillos-header">
            <h1 className="platillos-titulo">{vista === 'platillos' ? 'Catálogo de Platillos' : 'Gestión de Categorías'}</h1>
            <div className="platillos-botones-header">
              {vista === 'platillos' ? (
                <>
                  <button onClick={nuevoPlatillo} className="btn-nuevo-platillo">
                    <FaPlus /> Nuevo Platillo
                  </button>
                  <button onClick={nuevaCategoria} className="btn-nueva-categoria">
                    <FaPlus /> Nueva Categor&iacute;a
                  </button>
                  <button
                    onClick={abrirCostosModal}
                    className="btn-recalcular-costos"
                  >
                    <FaDollarSign /> Ver Costos
                  </button>
                  <button onClick={() => setVista('categorias')} className="btn-ver-categorias">
                    <FaList /> Ver Categor&iacute;as
                  </button>
                </>
              ) : (
                <>
                  <button onClick={() => setVista('platillos')} className="btn-ver-categorias">
                    <FaArrowLeft /> Volver a Platillos
                  </button>
                  <button onClick={nuevaCategoria} className="btn-nueva-categoria">
                    <FaPlus /> Nueva Categor&iacute;a
                  </button>
                </>
              )}
            </div>
          </div>

          {vista === 'platillos' ? (
            <>
              <div className="platillos-panel-filtros">
                <div className="platillos-filtros-content">
                  <div className="platillos-filtros-row">
                    <div className="platillos-filtro-item">
                      <label>B&uacute;squeda de Platillos</label>
                    </div>
                    <div className="platillos-filtro-derecha">
                      <div style={{ minWidth: '220px' }}>
                        <Select
                          value={categoriasOptions.find(o => o.value === filtroCategoria) || null}
                          onChange={(option) => setFiltroCategoria(option ? option.value : '')}
                          options={categoriasOptions}
                          placeholder="Todas las categorías..."
                          isSearchable={true}
                          isClearable={true}
                          noOptionsMessage={() => "No se encontraron categorías"}
                          classNamePrefix="select"
                          styles={selectStyles}
                          menuPortalTarget={document.body}
                        />
                      </div>
                      <SearchBar
                        value={filtroNombre}
                        onChange={(e) => setFiltroNombre(e.target.value)}
                        placeholder="Buscar por nombre..."
                        size="medium"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="platillos-panel-listado">
                <div className="platillos-tabla-container">
                  {platillosFiltrados.length === 0 ? (
                    <div className="platillos-sin-datos">No se encontraron platillos.</div>
                  ) : (
                    <table className="tabla-platillos">
                      <thead>
                        <tr>
                          <th>C&oacute;digo</th>
                          <th>Nombre</th>
                          <th>Precio</th>
                          <th>Costo</th>
                          <th>Categor&iacute;a</th>
                          <th>Impresora</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {platillosFiltrados.map(platillo => (
                          <tr key={platillo.idProducto}>
                            <td>{platillo.codigo}</td>
                            <td className="platillos-nombre">{platillo.nombre}</td>
                            <td className="platillos-precio">${Number(platillo.precio).toFixed(2)}</td>
                            <td className="platillos-costo">${Number(platillo.costo).toFixed(2)}</td>
                            <td>
                              <span className="platillos-categoria">{platillo.nombreCategoria}</span>
                            </td>
                            <td>{platillo.impresora}</td>
                            <td>
                              <div className="platillos-acciones">
                                <button
                                  onClick={() => editarPlatillo(platillo)}
                                  className="platillos-btn-accion platillos-btn-editar"
                                  title="Editar platillo"
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  onClick={() => { setPlatilloReceta(platillo); setShowRecetaModal(true); }}
                                  className="platillos-btn-accion platillos-btn-receta"
                                  title="Receta"
                                >
                                  <FaBook />
                                </button>
                                <button
                                  onClick={() => eliminarPlatillo(platillo)}
                                  className="platillos-btn-accion platillos-btn-eliminar"
                                  title="Eliminar platillo"
                                >
                                  <FaTrashAlt />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="platillos-acciones-container">
                  <div className="platillos-info">
                    <span>Total de platillos: {platillosFiltrados.length}</span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="platillos-panel-listado">
              <div className="platillos-tabla-container">
                {categorias.length === 0 ? (
                  <div className="platillos-sin-datos">No se encontraron categor&iacute;as.</div>
                ) : (
                  <table className="tabla-platillos">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nombre</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categorias.map(cat => (
                        <tr key={cat.idCategoria}>
                          <td>{cat.idCategoria}</td>
                          <td className="platillos-nombre">{cat.nombre}</td>
                          <td>
                            <div className="platillos-acciones">
                              <button
                                onClick={() => editarCategoria(cat)}
                                className="platillos-btn-accion platillos-btn-editar"
                                title="Editar categoría"
                              >
                                <FaEdit />
                              </button>
                              <button
                                onClick={() => eliminarCategoria(cat)}
                                className="platillos-btn-accion platillos-btn-eliminar"
                                title="Eliminar categoría"
                              >
                                <FaTrashAlt />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              <div className="platillos-acciones-container">
                <div className="platillos-info">
                  <span>Total de categor&iacute;as: {categorias.length}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />

      {/* Modal de edicion */}
      <FormModal
        isOpen={showModal}
        onClose={handleCloseModal}
        title={platilloSeleccionado ? 'Editar Platillo' : 'Nuevo Platillo'}
        onSave={guardarPlatillo}
        saveLabel={platilloSeleccionado ? 'Actualizar' : 'Crear'}
        isSaving={guardando}
        size="large"
        saveIcon={platilloSeleccionado ? <FaSave /> : <FaPlus />}
      >
        {/* Seccion: Datos Basicos */}
        <div className="platillos-modal-section">
          <div className="platillos-modal-section-title">
            <FaUtensils /> Datos B&aacute;sicos
          </div>
          <FormGrid columns={2} gap="12px">
            <FormField
              label="Nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleInputChange}
              placeholder="Nombre del platillo"
              required
              icon={<FaUtensils />}
            />
            <FormField
              label="Precio"
              type="number"
              name="precio"
              value={formData.precio}
              onChange={handleInputChange}
              placeholder="0.00"
              step="0.01"
              min="0"
              icon={<FaDollarSign />}
            />
            <FormField
              label="Costo"
              type="number"
              name="costo"
              value={formData.costo}
              onChange={handleInputChange}
              placeholder="0.00"
              step="0.01"
              min="0"
              icon={<FaDollarSign />}
            />
            <FormField
              label="C&oacute;digo"
              name="codigo"
              value={formData.codigo}
              onChange={handleInputChange}
              placeholder="C&oacute;digo del platillo"
              icon={<FaBarcode />}
            />
          </FormGrid>
        </div>

        {/* Seccion: Categoria */}
        <div className="platillos-modal-section">
          <div className="platillos-modal-section-title">
            <FaTh /> Categor&iacute;a
          </div>
          <div className="form-field">
            <label className="form-field-label">Categor&iacute;a</label>
            <Select
              value={categoriasOptions.find(o => o.value === String(formData.idCategoria)) || null}
              onChange={(option) => setFormData(prev => ({ ...prev, idCategoria: option ? option.value : '' }))}
              options={categoriasOptions}
              placeholder="Buscar categor&iacute;a..."
              isSearchable={true}
              isClearable={true}
              noOptionsMessage={() => "No se encontraron categor&iacute;as"}
              classNamePrefix="select"
              styles={selectStyles}
              menuPortalTarget={document.body}
            />
          </div>
        </div>

        {/* Seccion: Cocina / Impresion */}
        <div className="platillos-modal-section">
          <div className="platillos-modal-section-title">
            <FaPrint /> Cocina / Impresi&oacute;n
          </div>
          <FormGrid columns={2} gap="12px">
            <div className="form-field">
              <label className="form-field-label"><FaPrint style={{ marginRight: 4 }} /> Impresora</label>
              <Select
                value={impresoras.find(o => o.value === formData.impresora) || null}
                onChange={(option) => setFormData(prev => ({ ...prev, impresora: option ? option.value : '' }))}
                options={impresoras}
                placeholder="Seleccionar impresora..."
                isSearchable={true}
                isClearable={true}
                noOptionsMessage={() => "No se encontraron impresoras"}
                classNamePrefix="select"
                styles={selectStyles}
                menuPortalTarget={document.body}
              />
            </div>
            <div className="platillos-checkbox-field" style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
              <input
                type="checkbox"
                id="imprimirCocina"
                name="imprimirCocina"
                checked={formData.imprimirCocina === 1}
                onChange={handleInputChange}
              />
              <label htmlFor="imprimirCocina">Imprimir en cocina</label>
            </div>
          </FormGrid>
        </div>

        {/* Seccion: Disponibilidad */}
        <div className="platillos-modal-section">
          <div className="platillos-modal-section-title">
            <FaBoxOpen /> Disponibilidad
          </div>
          <FormGrid columns={2} gap="12px">
            <FormField
              label="Existencia"
              type="number"
              name="existencia"
              value={formData.existencia}
              onChange={handleInputChange}
              placeholder="0"
              min="0"
            />
          </FormGrid>
        </div>

      </FormModal>

      {/* Modal nueva categoría */}
      <FormModal
        isOpen={showCategoriaModal}
        onClose={() => { setShowCategoriaModal(false); setCategoriaSeleccionada(null); }}
        title={categoriaSeleccionada ? 'Editar Categoría' : 'Nueva Categoría'}
        onSave={guardarCategoria}
        saveLabel={categoriaSeleccionada ? 'Actualizar' : 'Crear'}
        isSaving={guardandoCategoria}
        size="large"
        saveIcon={categoriaSeleccionada ? <FaSave /> : <FaPlus />}
      >
        <div className="platillos-modal-section">
          <div className="platillos-modal-section-title">
            <FaTh /> Datos de la Categor&iacute;a
          </div>
          <FormField
            label="Nombre"
            name="nombre"
            value={categoriaFormData.nombre}
            onChange={handleCategoriaInputChange}
            placeholder="Nombre de la categoría"
            required
            icon={<FaTh />}
          />
        </div>

      </FormModal>

      {/* Modal ver costos */}
      <FormModal
        isOpen={showCostosModal}
        onClose={() => setShowCostosModal(false)}
        title="Costos de Platillos y Preparados"
        onSave={() => setShowCostosModal(false)}
        saveLabel="Cerrar"
        saveIcon={<FaTimes />}
        size="xlarge"
        showCancel={false}
      >
        {/* Tabs */}
        <div style={{ display: 'flex', gap: '0', marginBottom: '12px', borderBottom: '2px solid #e2e8f0' }}>
          <button
            onClick={() => { setTabCostos('platillos'); setBusquedaCostos(''); }}
            style={{
              padding: '8px 20px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
              background: tabCostos === 'platillos' ? '#FF9800' : 'transparent',
              color: tabCostos === 'platillos' ? 'white' : '#666',
              borderRadius: '6px 6px 0 0', transition: 'all 0.2s'
            }}
          >
            <FaUtensils style={{ marginRight: '6px' }} />
            Platillos ({platillos.length})
          </button>
          <button
            onClick={() => { setTabCostos('preparados'); setBusquedaCostos(''); }}
            style={{
              padding: '8px 20px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
              background: tabCostos === 'preparados' ? '#FF9800' : 'transparent',
              color: tabCostos === 'preparados' ? 'white' : '#666',
              borderRadius: '6px 6px 0 0', transition: 'all 0.2s'
            }}
          >
            <FaBoxOpen style={{ marginRight: '6px' }} />
            Preparados ({preparados.length})
          </button>
        </div>

        {/* Buscador */}
        <div style={{ marginBottom: '10px', position: 'relative' }}>
          <input
            type="text"
            value={busquedaCostos}
            onChange={(e) => setBusquedaCostos(e.target.value)}
            placeholder={tabCostos === 'platillos' ? 'Buscar platillo...' : 'Buscar preparado...'}
            style={{
              width: '100%', padding: '8px 32px 8px 12px', border: '1px solid #d1d5db',
              borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box'
            }}
          />
          {busquedaCostos && (
            <button
              onClick={() => setBusquedaCostos('')}
              style={{
                position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '14px'
              }}
            >
              <FaTimes />
            </button>
          )}
        </div>

        {/* Tabla Platillos */}
        {tabCostos === 'platillos' && (
          <>
            <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '6px' }}>
              <table className="tabla-platillos" style={{ fontSize: '12px' }}>
                <thead>
                  <tr>
                    <th>Platillo</th>
                    <th>Categoría</th>
                    <th style={{ width: '100px' }}>Costo</th>
                    <th style={{ width: '100px' }}>Precio</th>
                    <th style={{ width: '100px' }}>Margen</th>
                  </tr>
                </thead>
                <tbody>
                  {platillos
                    .filter(p => {
                      if (!busquedaCostos) return true;
                      const texto = busquedaCostos.toLowerCase();
                      return p.nombre?.toLowerCase().includes(texto) || p.nombreCategoria?.toLowerCase().includes(texto);
                    })
                    .map(p => {
                      const costo = Number(p.costo) || 0;
                      const precio = Number(p.precio) || 0;
                      const margen = precio > 0 ? ((precio - costo) / precio * 100) : 0;
                      return (
                        <tr key={p.idProducto}>
                          <td>{p.nombre}</td>
                          <td><span className="platillos-categoria">{p.nombreCategoria}</span></td>
                          <td className="text-right" style={{ fontWeight: '600' }}>${costo.toFixed(2)}</td>
                          <td className="text-right">${precio.toFixed(2)}</td>
                          <td className="text-right" style={{
                            fontWeight: '600',
                            color: margen >= 50 ? '#2e7d32' : margen >= 30 ? '#FF9800' : '#c62828'
                          }}>
                            {margen.toFixed(1)}%
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: '8px', fontSize: '11px', color: '#666', display: 'flex', justifyContent: 'space-between' }}>
              <span>Total: {platillos.filter(p => {
                if (!busquedaCostos) return true;
                const texto = busquedaCostos.toLowerCase();
                return p.nombre?.toLowerCase().includes(texto) || p.nombreCategoria?.toLowerCase().includes(texto);
              }).length} platillos</span>
              <span>
                <span style={{ color: '#2e7d32' }}>■</span> {'≥50%'}
                {' '}
                <span style={{ color: '#FF9800' }}>■</span> {'≥30%'}
                {' '}
                <span style={{ color: '#c62828' }}>■</span> {'<30%'}
              </span>
            </div>
          </>
        )}

        {/* Tabla Preparados */}
        {tabCostos === 'preparados' && (
          <>
            <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '6px' }}>
              <table className="tabla-platillos" style={{ fontSize: '12px' }}>
                <thead>
                  <tr>
                    <th>Preparado</th>
                    <th style={{ width: '100px' }}>Unidad</th>
                    <th style={{ width: '120px' }}>Ingredientes</th>
                    <th style={{ width: '100px' }}>Costo</th>
                  </tr>
                </thead>
                <tbody>
                  {preparados
                    .filter(p => {
                      if (!busquedaCostos) return true;
                      return p.nombre?.toLowerCase().includes(busquedaCostos.toLowerCase());
                    })
                    .map(p => (
                      <tr key={p.idPreparado}>
                        <td>{p.nombre}</td>
                        <td>{p.unidad}</td>
                        <td className="text-right">{p.numIngredientes}</td>
                        <td className="text-right" style={{ fontWeight: '600' }}>${(Number(p.costo) || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: '8px', fontSize: '11px', color: '#666' }}>
              Total: {preparados.filter(p => {
                if (!busquedaCostos) return true;
                return p.nombre?.toLowerCase().includes(busquedaCostos.toLowerCase());
              }).length} preparados
            </div>
          </>
        )}
      </FormModal>

      {/* Modal de receta */}
      <RecetaModal
        isOpen={showRecetaModal}
        onClose={() => { setShowRecetaModal(false); setPlatilloReceta(null); }}
        platillo={platilloReceta}
      />
    </div>
  );
};

export default Platillos;